import page from 'shared/pages'
import List from './List'
export default [
  {
    path: '',
    name: 'privilege_list',
    component: page.createList(List),
  },
  {
    path: 'new',
    name: 'privilege_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'privilege_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'privilege_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
